import React from 'react';

import Chip from '@mui/material/Chip';

import type { Ticket } from 'services/types/ticket';

interface TicketStatusChipProps {
  status: Ticket['status'];
  size: 'small' | 'medium';
}

const getStatusColor = (status: Ticket['status']) => {
  switch (status) {
    case 'PENDING':
      return 'warning';
    case 'IN_PROGRESS':
      return 'info';
    case 'ANALYSIS_WITH_AI':
      return 'info';
    case 'MANUAL_ANALYSIS_PENDING':
      return 'info';
    case 'CLOSED':
      return 'success';
    case 'FAILED':
      return 'error';
    default:
      return 'default';
  }
};

const getStatusLabel = (status: Ticket['status']) => {
  switch (status) {
    case 'PENDING':
      return 'Pendiente - Nuevo mensaje';
    case 'IN_PROGRESS':
      return 'En Progreso';
    case 'ANALYSIS_WITH_AI':
      return 'Analizando automáticamente';
    case 'MANUAL_ANALYSIS_PENDING':
      return 'Análisis manual pendiente';
    case 'CLOSED':
      return 'Completado - Resuelto';
    case 'FAILED':
      return 'Fallido';
    default:
      return status;
  }
};

const TicketStatusChip: React.FC<TicketStatusChipProps> = ({ status, size = 'small' }) => (
  <Chip label={getStatusLabel(status)} color={getStatusColor(status)} size={size} sx={{ fontWeight: 500 }} />
);

export default TicketStatusChip;
